import { isAfter } from 'date-fns/isAfter'
import { isBefore } from 'date-fns/isBefore'
import { subMinutes } from 'date-fns/subMinutes'

import type { TimeSlot } from 'bl-flows-core'

// BUSINESS LOGIC:
// This filters the available pickup slots based on the earliest activity time or entry time
// and the duration of the route (if it will be on time)
export const getAvailablePickupSlots = (
  timeSlots: TimeSlot[],
  duration: number,
  entryDate: Date,
  firstActivityDate?: string
) => {
  if (!timeSlots || timeSlots.length === 0) {
    return []
  }

  // find earliest booking time (restaurant reservation or ticket time)
  let earliestDate
  if (firstActivityDate) {
    earliestDate = isBefore(new Date(firstActivityDate), entryDate)
      ? firstActivityDate
      : entryDate
  } else {
    earliestDate = entryDate
  }

  return timeSlots.filter(
    slot =>
      !isAfter(
        new Date(slot.time),
        subMinutes(new Date(earliestDate), duration)
      )
  )
}
